import React from "react";

import { Slide, Text, BlockQuote, Quote, Cite, Appear } from "spectacle";
import { CustomHeading } from "../../custom-style";

export default () => {
  return (
    <Slide>
      <CustomHeading fit>¿Qué aprenderemos hoy?</CustomHeading>
    </Slide>
  );
};



// WEBPACK FOOTER //
// ./src/slides/01-introduction/04-workshop-goal.js